import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles, permission, permissions = [] }) {
    const { user, loading, hasPermission, hasAnyPermission } = useAuth();
    const location = useLocation();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-50">
                <div className="text-slate-500">Cargando...</div>
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
    }
    if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
    if (permission && !hasPermission(permission)) return <Navigate to="/dashboard" replace />;
    if (permissions.length && !hasAnyPermission(permissions)) return <Navigate to="/dashboard" replace />;
    return children;
}
